import React from "react";
import LayoutProjects from "./LayoutProjects";
import RaImg from "../../img/png/ra-img.png";
import RaVideo from "../../img/mp4/ra-video.mp4";

export default function Webapp() {
  let language = localStorage.getItem("language");
  return (
    <LayoutProjects
      title={language === "english" ? "WEBAPP FULLSTACK" : "APLICACION WEB"}
      features={
        language === "english"
          ? [
              "Login",
              "Forum",
              "Menu responsive",
              "CRUD",
              "Contact form",
              "Admin Panel",
              "Email sender",
              "Menu administrator",
            ]
          : [
              "Inicio de sesión",
              "Foro",
              "Menu responsivo",
              "CRUD",
              "Formulario de contacto",
              "Panel administrativo",
              "Correos",
              "Administar menús",
            ]
      }
      img={RaImg}
      description={
        language === "english"
          ? "Web App created in the 2020, this page can be modified in the admin panel, the page use middleware's denying unauthorizathed conections."
          : "Aplicacion web creada en el 2020, esta página puede ser modificada en el panel administrativo, la página usa middlewares negando el acceso de conexiones no autorizadas."
      }
      color="#58f"
      textColor="#fff"
      video={RaVideo}
      tecno={["React", "Node", "Express", "MongoDB", "Antd"]}
      link="https://radevelopment.netlify.app/"
    />
  );
}
